import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Vérifier si déjà connecté
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      // Vérifier si le token est encore valide
      axios.post(`${API}/admin/verify?token=${token}`)
        .then(() => navigate('/admin/dashboard'))
        .catch(() => localStorage.removeItem('adminToken'));
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      const { access_token } = response.data;
      
      localStorage.setItem('adminToken', access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#8B9E8A]/10 to-[#C5A572]/10 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-[#C5A572]/30 shadow-2xl">
        <CardHeader className="bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white rounded-t-lg text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full">
              <Lock className="h-8 w-8" />
            </div>
          </div>
          <CardTitle className="text-2xl">Espace Administrateur</CardTitle>
          <p className="text-white/80 text-sm mt-2">Gratia Animalis</p>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center gap-2">
                <AlertCircle className="h-5 w-5" />
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-[#8B9E8A] mb-2">
                Mot de passe
              </label>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="border-[#8B9E8A]/20 focus:border-[#C5A572] pr-10"
                  placeholder="Entrez votre mot de passe"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#C5A572] to-[#B8860B] text-white hover:shadow-xl transition-all duration-300 font-bold py-3"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a
              href="/"
              className="text-[#8B9E8A] hover:text-[#C5A572] text-sm transition-colors"
            >
              ← Retour au site
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
